module.exports = __webpack_public_path__ + "img/plus-order.7e3e67ed.svg";